import React, { useContext } from 'react';
import { AuthStore } from './contexts/auth';
import { PusherProvider, PusherStore } from './contexts/pusher';
import { MatchingStore } from './contexts/matching';
import { TravelerProfileSuggestionsStore } from './contexts/traveler-profile-suggestions';

export interface ProviderProps {
  children: React.ReactNode;
}

export const useAuthStore = () => useContext(AuthStore);
export const useMatchingStore = () => useContext(MatchingStore);
export const usePusherStore = () => useContext(PusherStore);
export const useTravelerProfileSuggestionsStore = () => useContext(TravelerProfileSuggestionsStore);

const StoreProvider = ({ children }: ProviderProps) => (
  <PusherProvider>
    {children}
  </PusherProvider>
);

export default StoreProvider;
